import { array, option } from 'fp-ts';
import { Reservation } from '@mews-commander/data-access';

export const mapSlotIds = array.filterMap(({ assignedResourceId, assignedSlotId }: Reservation) =>
    !assignedResourceId && assignedSlotId ? option.some(assignedSlotId) : option.none
);

export const mapRequestedCategoryIds = array.filterMap(
    ({ assignedResourceId, assignedSlotId, requestedCategoryId }: Reservation) =>
        !assignedResourceId && !assignedSlotId ? option.some(requestedCategoryId) : option.none
);

export const mapAssignedResourceIds = array.filterMap(
    option.fromNullableK(({ assignedResourceId }: Reservation) => assignedResourceId)
);
